export const tableColumns = [
  {
    label: "角色名称",
    value: "name"
  },
  {
    label: "角色描述",
    value: "description"
  },
  {
    label: "人数",
    value: "userNum"
  }
]

export const tableData = [
  {
    name: "工作表1",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表2",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表3",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表4",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表1",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表2",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表3",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表4",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表1",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表2",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表3",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表4",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表1",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表2",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表3",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表4",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表1",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表2",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表3",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表4",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表1",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表2",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表3",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表4",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  }
]
